import { useTranslation } from 'react-i18next';
import { LANGUAGE_NAMES, type TranslationDto, type UiLanguage } from '@b4b/shared';

/** 🌐 marker next to the source name on translated cards. */
export default function TranslatedBadge({
  translation,
  className = '',
}: {
  translation: TranslationDto;
  className?: string;
}) {
  const { t } = useTranslation();
  const source =
    translation.sourceLang && translation.sourceLang in LANGUAGE_NAMES
      ? LANGUAGE_NAMES[translation.sourceLang as UiLanguage]
      : (translation.sourceLang ?? '?').toUpperCase();
  return (
    <span
      className={`inline-flex items-center gap-0.5 ${className}`}
      title={t('translation.translatedFrom', { source })}
      aria-label={t('translation.translatedFrom', { source })}
    >
      🌐
    </span>
  );
}
